export enum YesNoModalInputTypeEnum {
  NONE = "NONE",
  TEXT = "TEXT",
  DATE = "DATE"
}

